import type { WJobOffersTranslations } from "./pl";

export const en: WJobOffersTranslations = {
  apply: "Apply",
  sendCv: "Send CV",
};
